import '@babel/polyfill' //为了兼容ie 放在最顶部
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//引入elementui组件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/index.css' // global css
//引入store
import store from './store'

import './permission' // permission control

//分页
import Pagination from "@/components/Pagination";
import request from '@/utils/request';
import Print from 'vue-print-nb'

// 全局组件挂载
Vue.component('Pagination', Pagination)

ElementUI.Drawer.props.wrapperClosable = false;
ElementUI.Drawer.props.closeOnPressEscape = false
ElementUI.Dialog.props.closeOnClickModal = false;
ElementUI.Dialog.props.closeOnPressEscape = false;
Vue.use(ElementUI)
Vue.use(Print);

Vue.config.productionTip = false

Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message({ showClose: true, message: msg, type: "warning" });
}

//根据tenant获取org_code
function findOrgCodeByTenant(tenant) {
  return request({
      url: '/bussiness/org/findOrgCodeByTenant/' + tenant,
      method: 'get'
  });
}
router.beforeEach((to, from, next) => {
  let tenant = window.location.hostname;
  findOrgCodeByTenant(tenant).then(res => {
    if (res.code === 200) {
      let orgCode = res.msg;
      window.sessionStorage.setItem("orgCode", orgCode);
    }
  }).then(() => {
    next()
  })
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js